import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'
var fechaHoy = moment().format('YYYY-MM-DD');

//constantes
const dataInicial = {
    data: {},
    fc_08: {
        fechasolicitud: fechaHoy,
        tipoinstalacion: '',
        nombreresponsable: '',
        correoelectronico: '',
        telefono: '',
        domicilio: '',
        vencimientocertificado: false,
        cambioaduana: false,
        especificaraduana: '',
        cambiocatidad: false,
        especificarcantidad: '',
        cambiodestinatario: false,
        especificardestinatario: '',
        domicilioimportador: false,
        especificardomicilio: '',
        otros: false,
        especificarotros: '',
    },
    certificados: {},
    loading: false,
    fc_08Map: {},
    certificadosMap: [],
    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    cliente: [],
    instalacionesCliente: [],
    instalacionesFiltro: [],
    dataLogin: [],
    granel: false,
    exportacion: false,
    dataDocumentacion: {},
    files: [],
    filesCertificado: [],
    filesExportacionMap: [],
    filesGranelMap: []
}

//types
const OBTENER_FC_08_DETALLE_EXITO = 'OBTENER_FC_08_DETALLE_EXITO'
const OBTENER_FC_08_MAP_EXITOB = 'OBTENER_FC_08_MAP_EXITOB'
const AGREGAR_FC_08_EXITO = 'AGREGAR_FC_08_EXITO'
const AGREGAR_CERTIFICADO_FC_08_EXITO = 'AGREGAR_FC_08_CERTIFICADO_EXITO'
const AGREGAR_FC_08_BORRADOR_EXITO = 'AGREGAR_FC_08_BORRADOR_EXITO'
const ACTUALIZAR_FC_08_ESTATUS_EXITO = 'ACTUALIZAR_FC_08_ESTATUS_EXITO'
const ELIMINAR_FC_08_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_08_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_08_ANEXOPRODUCTO_EXITO_BD = 'ELIMINAR_FC_08_ANEXOPRODUCTO_EXITO_BD'
const OBTENER_CLIENTE_POR_LOGIN_EXITO_08 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_08'
const OBTENER_FC_08_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_08_CONTADOR_FECHA_FOLIO_EXITO'
const AGREGAR_ARCHIVO_FC_08_EXITO = 'AGREGAR_ARCHIVO_FC_08_EXITO'
const ACTUALIZAR_ARCHIVO_FC_08_EXITO = 'ACTUALIZAR_ARCHIVO_FC_08_EXITO'
const AGREGAR_FC_08_FECHA_EXITO = 'AGREGAR_FC_08_FECHA_EXITO'
const ACTUALIZAR_FC_08_SOLICITUD = 'ACTUALIZAR_FC_08_SOLICITUD'
export const ObtenerClientePorLogin08 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_08,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera
            const fullUrlInstalaciones = host + `InformacionValida/obtenerTodosAnexosCliente/${idcliente}`
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            const fullUrlDomicilioCliente = host + `InformacionValida/obtenerDomicilioFiscalClientePorCliente/${idcliente}`

            let resinstalaciones = await axios.get(fullUrlInstalaciones)
            console.log('data ressss ', resinstalaciones.data.data)
            const resdomicilio = await axios.get(fullUrlDomicilioCliente)
            let datos = []
            let instalaciones = []
            let dat = []
            dat.push(resdomicilio.data.data)
            //let onjUnidos = Object.assign(resinstalaciones.data.data, dat)
            let onjUnidos = [...resinstalaciones.data.data, ...dat];
            instalaciones.push(onjUnidos)
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(res.data.data, instalaciones, datosLogin)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_08_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFC_08Accion = createAsyncThunk(
    AGREGAR_FC_08_EXITO,
    async (data) => {
        try {
            const certificados = data.certificados

            const fullUrl = host + `FC_08/agregarNuevoFC_08`
            const urlAnexoCertificados = host + `FC_08/agregarFormatoFC08_AnexoCertificados`

            const res = await axios.post(fullUrl, { data: data.solicitud })
            let idfc08_renvacioncertificado = res.data.data.idfc08_renvacioncertificado
            for (let i in certificados) {
                const { id, ...anexo } = certificados[i]
                delete anexo.fc_08archivoscertificados
                anexo.idfc08_renvacioncertificado = idfc08_renvacioncertificado
                const result = await axios.post(urlAnexoCertificados, { data: anexo })
            }
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerFC_08SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_08_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_08/obtenerFormatoFC08_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            console.log("los datos de res es  ", res.data.data)
            const fc_08_anexocertificados = []
            const documentosCertificados = []
            let granel = false
            let exportacion = false
            for (let i in res.data.data.fc_08_anexocertificados) {
                res.data.data.fc_08_anexocertificados[i]['id'] = uuidv4()
                if (res.data.data.fc_08_anexocertificados?.[i]?.tipocertificado === 'Granel') granel = true
                if (res.data.data.fc_08_anexocertificados?.[i]?.tipocertificado === 'Exportacion') exportacion = true
                if (res.data.data.fc_08_anexocertificados?.[i]?.tipocertificado === 'Exportacion promocion') exportacion = true

                    for (const j in res.data.data.fc_08_anexocertificados[i].fc_08archivoscertificados) {
                        const { ...anexo } = res.data.data.fc_08_anexocertificados[i].fc_08archivoscertificados[j]
                        const data = {
                            id: anexo.nameid,
                            file: { name: await getNameFile(anexo.ruta) },
                            idAnexo: anexo.idfc_08archivoscertificados,
                            idAnexoFK: res.data.data.fc_08_anexocertificados[i].idfc30_anexoproducto,
                            estatus: true,
                        }
                        documentosCertificados.push(data)
                    }
                fc_08_anexocertificados.push(res.data.data.fc_08_anexocertificados[i])
            }

            return {
                data: res.data.data, fc_08_anexocertificados, documentosCertificados,
                granel, exportacion
            }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const agregarFileFC_08 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_08_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_08 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_08_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFC_08Fecha = createAsyncThunk(
    AGREGAR_FC_08_FECHA_EXITO,
    async (data) => {
        try {
            const actualizarFC_08 = host + `FC_08/actualizarFC_08`
            const res = await axios.put(actualizarFC_08, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarFC_08Estatus = createAsyncThunk(
    ACTUALIZAR_FC_08_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_08Map = createAsyncThunk(
    OBTENER_FC_08_MAP_EXITOB,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_08_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)

            const certificadosMap = await obtenerCertificadosMap(solicitudId)

            const solicitudMap = {
                data: res.data.data,
                anexoCertificadoMap: certificadosMap.anexoCertificadoMap,
                archivoGranelMap: certificadosMap.archivoGranelMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerCertificadosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_08/obtenerFormatoFC08_ConDetalle/${idSolicitud}`
        const obtenerCertificadosMap = host + `MapSolicitud/obtenerMapFC_08_AnexoRenovacionDeCertificado/`
        const obtenerArchivoGranelMap = host + `MapSolicitud/obtenerMapFC_08_ArchivosGranel/`
        const res = await axios.get(fullUrl)
        console.log("los datos de res ", res.data.data)
        let anexoCertificadoMap = []
        for (const anexo of res.data.data.fc_08_anexocertificados) {
            const resMap = await axios.get(obtenerCertificadosMap + anexo.idfc08_anexorenovacion)
            anexoCertificadoMap.push(resMap.data.data)
        }
        let archivoGranelMap = []
        for (const anexo of res.data.data.fc_08_anexocertificados) {
                for (const i in anexo.fc_08archivoscertificados) {
                    const resMap = await axios.get(obtenerArchivoGranelMap + anexo.fc_08archivoscertificados?.[i].idfc_08archivoscertificados)
                    resMap.data.data.idAnexoBD = resMap.data.data.idfc_08archivoscertificados
                    archivoGranelMap.push(resMap.data.data)
                }
        }

        return { anexoCertificadoMap: anexoCertificadoMap, archivoGranelMap: archivoGranelMap }
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_08Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_08_SOLICITUD,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const certificados = data.certificados

            const actualizarFC_08 = host + `FC_08/actualizarFC_08`
            const urlActualizarAnexoCertificados = host + 'FC_08/actualizarFormatoFC08_AnexoCertificados'
            const urlAnexoCertificados = host + `FC_08/agregarFormatoFC08_AnexoCertificados`

            const res = await axios.put(actualizarFC_08, solicitud)
            let idfc08_renvacioncertificado = res.data.data.idfc08_renvacioncertificado

            for (let i in certificados) {
                const { id, fc_08archivoscertificados, ...anexo } = certificados[i]
                if (anexo.idfc08_anexorenovacion) {
                    const result = await axios.put(urlActualizarAnexoCertificados, { data: anexo })
                } else {
                    anexo.idfc08_renvacioncertificado = idfc08_renvacioncertificado
                    await axios.post(urlAnexoCertificados, { data: anexo })
                }

            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_08SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_08_SOLICITUD_EXITO_BD,
    async (id) => {
        try {

            const fullUrlSolicitud = host + `FC_08/eliminarFC_08/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return resultDelete
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_08AnexoProductoBD = createAsyncThunk(
    ELIMINAR_FC_08_ANEXOPRODUCTO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_08/eliminarFormatoFC08_AnexoCertificados/${id}`
            const res = await axios.delete(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


export const fc08Slice = createSlice({
    name: 'fc08Slice',
    initialState: dataInicial,
    reducers: {
        editarFC_08AnexoCertificado(state, { payload }) {
            const inputCertificado = state.certificados.data.filter(field => field.id === payload.id)
            if (inputCertificado.length > 0) {
                inputCertificado[0][payload.campo] = payload.valor
            }
        },
        actualizarFC_08PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        agregarFC_08AnexoCertificado(state, { payload }) {
            state.certificados.data.push(payload)
        },
        agregarFC_08AnexoCertificados(state, { payload }) {
            state.certificados = payload
        },
        setCambiosFC_08SolicitudNueva(state, { payload }) {
            state.fc_08 = payload
        },
        setCambiosFC_08SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        actualizarModoCorrecionFC_08(state, { payload }) {
            state.modoCorreccion = payload
        },
        actualizarFC_08PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        guardarCambiosFC_08Certificado(state, { payload }) {
            state.certificados = payload
        },
        resetDataFC_08(state, { payload }) {
            return dataInicial
        },
        actualizarModoBorradorFC_08(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        agregarInstalacionesFiltro(state, { payload }) {
            state.instalacionesFiltro = payload
        },
    },
    extraReducers: {
        [ObtenerClientePorLogin08.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            state.instalacionesCliente = payload[1][0]
            state.dataLogin = payload[2][0][0]
        },
        [actualizarFC_08Estatus.fulfilled]: (state, { payload }) => {
        },
        [agregarFC_08Accion.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_08SolicitudDetalle.fulfilled]: (state, { payload }) => {
            console.log("los daros de detalle ", payload)
            state.data = payload.data
            state.fc_08 = payload.data
            state.dataDocumentacion = payload.data
            state.certificados = payload.fc_08_anexocertificados
            state.filesCertificado = payload.documentosCertificados
            state.exportacion = payload.exportacion
            state.granel = payload.granel
        },

        [obtenerFC_08Map.fulfilled]: (state, { payload }) => {
            state.fc_08Map = payload.data
            state.certificadosMap = payload.anexoCertificadoMap
            state.filesGranelMap = payload.archivoGranelMap
        },
        [eliminarFC_08AnexoProductoBD.fulfilled]: (state, { payload }) => {
            const filtro = { data: state?.certificados?.data?.filter(anexo => anexo.idfc08_anexorenovacion !== payload) }
            state.certificados = filtro
        },
        [eliminarFC_08SolicitudBD.fulfilled]: (state, { payload }) => {
        },
       
    }
})

export const {
    agregarFC_08AnexoCertificado,
    editarFC_08AnexoCertificado,
    agregarFC_08AnexoCertificados,
    actualizarFC_08PaginaActiva,
    actualizarModoBorradorFC_08,
    actualizarModoCorrecionFC_08,
    resetDataFC_08,
    guardarCambiosFC_08Certificado,
    setCambiosFC_08SolicitudBorrador,
    setCambiosFC_08SolicitudNueva,
    agregarInstalacionesFiltro } = fc08Slice.actions
export const FC08ReducerBeneficiario = fc08Slice.reducer
